import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, Loading, ModalController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
/* Model */
import { UserModel } from '../../models/user/user.model';
/* Pages & Popovers */
/* Services */
import { UtilService } from '../../services/util.service';

@IonicPage()
@Component({
  selector: 'user-profile',
  templateUrl: 'user-profile.html'
})
export class UserProfile {
  user: UserModel = <UserModel>{};
  isVN: Boolean = false;
  
  constructor(
    private storage: Storage, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController, public loadingCtrl: LoadingController, private modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public util: UtilService
    ) {
      this.isVN = this.util.isRemoveDKSHLogoForVN();
  }

  ngOnInit(){
    this.storage.get('user').then((value)=>{
      this.user = value; 
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-profile/user-profile.ts